const STORAGE_KEYS = {
  clients: 'dm_clients',
  models: 'dm_models',
  measurements: 'dm_measurements',
  payments: 'dm_payments'
}

function read(key) {
  try {
    return JSON.parse(localStorage.getItem(key) || '[]')
  } catch (e) {
    return []
  }
}

function write(key, arr) {
  localStorage.setItem(key, JSON.stringify(arr))
}

export function getClients() {
  return read(STORAGE_KEYS.clients)
}

export function saveClient(client) {
  const list = read(STORAGE_KEYS.clients)
  if (!client.id) {
    client.id = Date.now().toString()
    list.push(client)
  } else {
    const idx = list.findIndex(c => c.id === client.id)
    if (idx !== -1) list.splice(idx, 1, client)
    else list.push(client)
  }
  write(STORAGE_KEYS.clients, list)
}

export function getClientById(id) {
  return getClients().find(c => c.id === id) || null
}

export function getModels() {
  return read(STORAGE_KEYS.models)
}

export function saveModel(model) {
  const list = read(STORAGE_KEYS.models)
  if (!model.id) {
    model.id = Date.now().toString()
    list.push(model)
  } else {
    const idx = list.findIndex(m => m.id === model.id)
    if (idx !== -1) list.splice(idx, 1, model)
    else list.push(model)
  }
  write(STORAGE_KEYS.models, list)
}

export function getMeasurements() {
  return read(STORAGE_KEYS.measurements)
}

export function saveMeasurement(measurement) {
  const list = read(STORAGE_KEYS.measurements)
  if (!measurement.id) {
    measurement.id = Date.now().toString()
    list.push(measurement)
  } else {
    const idx = list.findIndex(m => m.id === measurement.id)
    if (idx !== -1) list.splice(idx, 1, measurement)
    else list.push(measurement)
  }
  write(STORAGE_KEYS.measurements, list)
}

export function getPayments() {
  return read(STORAGE_KEYS.payments)
}

export function savePayment(payment) {
  const list = read(STORAGE_KEYS.payments)
  if (!payment.id) {
    payment.id = Date.now().toString()
    list.push(payment)
  } else {
    const idx = list.findIndex(p => p.id === payment.id)
    if (idx !== -1) list.splice(idx, 1, payment)
    else list.push(payment)
  }
  write(STORAGE_KEYS.payments, list)
}

export default {
  getClients,
  saveClient,
  getClientById,
  getModels,
  saveModel,
  getMeasurements,
  saveMeasurement,
  getPayments,
  savePayment
}
